var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 2.667c2.213 0 4 1.786 4 4s-1.787 4-4 4-4-1.787-4-4 1.786-4 4-4m0 19.066a9.6 9.6 0 0 1-8-4.293c.04-2.653 5.333-4.107 8-4.107 2.653 0 7.96 1.454 8 4.107a9.6 9.6 0 0 1-8 4.293"
})));
export default SvgUser;